export default __webpack_public_path__ + "static/media/icon-error-2.d7b2411e.svg";